import { DemoUserObject } from "./usersData";

export type ChatMsgObj = {
    id: string;
    msg?: string;
    img?: string;
    time: string;
    user: DemoUserObject;
    read: boolean;
    sended: boolean;
};

export const chat_data: ChatMsgObj[] = [
    {
        id: "1",
        msg: "test msg",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "2",
        img: "https://images.pexels.com/photos/305070/pexels-photo-305070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "3",
        msg: "test msg",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        read: true,
        sended: false
    },
    {
        id: "4",
        img: "https://images.pexels.com/photos/305070/pexels-photo-305070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        read: true,
        sended: false
    },
    {
        id: "5",
        msg: "test msg",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "6",
        img: "https://images.pexels.com/photos/305070/pexels-photo-305070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        read: true,
        sended: false
    },
    {
        id: "7",
        img: "https://images.pexels.com/photos/305070/pexels-photo-305070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "8",
        msg: "test msg",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        read: true,
        sended: false
    },
    {
        id: "9",
        msg: "test msg",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "10",
        msg: "test msg",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "11",
        msg: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque perspiciatis sequi esse error, eius ea atque! Repellat accusamus veniam qui, adipisci ex esse id ut facilis expedita temporibus reiciendis omnis!",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "12",
        msg: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque perspiciatis sequi esse error, eius ea atque! Repellat accusamus veniam qui, adipisci ex esse id ut facilis expedita temporibus reiciendis omnis!",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        read: true,
        sended: false
    },
    {
        id: "13",
        img: "https://images.pexels.com/photos/1545743/pexels-photo-1545743.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 8,
            name: "Al Khaldi",
            username: "alkhaldi",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
        },
        read: true,
        sended: false
    },
    {
        id: "14",
        msg: "https://img.huffingtonpost.com/asset/5ab4d4ac2000007d06eb2c56.jpeg?cache=sih0jwle4e&ops=1910_1000",
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: true,
        sended: true
    },
    {
        id: "15",
        msg: `Write short paragraphs and cover one topic per paragraph. Long paragraphs discourage users from even trying to understand your material. Short paragraphs are easier to read and understand.

Writing experts recommend paragraphs of no more than 150 words in three to eight sentences. Paragraphs should never be longer than 250 words. Vary the lengths of your paragraphs to make them more interesting. As with sentence length, if all paragraphs are the same size your writing will be choppy.`,
        time: "18 Dec, 2023 18:30",
        user: {
            id: 5,
            name: "Richard Kettleboroug",
            username: "richard11",
            url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
        },
        read: false,
        sended: true
    }
];

/*
sended text
,{
    id: "1",
    msg: "test msg",
    time: "18 Dec, 2023 18:30",
    user: {
        id: 5,
        name: "Richard Kettleboroug",
        username: "richard11",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
    },
    read: true,
    sended: true,
}

//sended img
,{
    id: "2",
    img: "https://images.pexels.com/photos/305070/pexels-photo-305070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    time: "18 Dec, 2023 18:30",
    user: {
        id: 5,
        name: "Richard Kettleboroug",
        username: "richard11",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120514050aLQA74mWqy.jpg"
    },
    read: true,
    sended: true
}
*/

/*
recieved text
,{
    id: "1",
    msg: "test msg",
    time: "18 Dec, 2023 18:30",
    user: {
        id: 8,
        name: "Al Khaldi",
        username: "alkhaldi",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
    },
    read: true,
    sended: false,
}

//recieved img
,{
    id: "2",
    img: "https://images.pexels.com/photos/305070/pexels-photo-305070.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    time: "18 Dec, 2023 18:30",
    user: {
        id: 8,
        name: "Al Khaldi",
        username: "alkhaldi",
        url: "https://momeento.nyc3.cdn.digitaloceanspaces.com/images/1702120922542SpcfecLMl4.jpg"
    },
    read: true,
    sended: false
}
*/
